<template>
  <div class="hy-piao">
    <div class="title">
      <h5>申请发票 <span @click="goNumber">共{{piao_data.length}}张 <b>申请开多张发票 </b></span></h5>
    </div>
    <div class="typelist">
      <!-- 循环字段-->
      <div v-for="(items,index) in typelist" :key="index">
        <!-- 文本输入框-->
        <div class="van-input" v-if="items.type == 1 && items.isShow">
          <span class="van-field__label">{{items.title + '：'}}</span> <el-input   v-model="checkbox[items.name]"  :placeholder="items.placeholder+(items.isRequired ?  '(必填)':'(非必填)')" :maxlength="100" @blur="validator(index)" :readonly="items.disabled"></el-input>
         </div>
        <!-- 单选框 -->
        <div class="van-radio-groupBox" v-else-if="items.type == 2 && items.isShow">
          <h5>{{items.title}}：</h5>

          <el-radio v-model="checkbox[items.name]"  :disabled="!val.check" v-for="val in items.options" :label="val.value" @change="changeRadio(items.name)">{{val.text}}</el-radio>
        </div>
        <!--下拉选择-->
        <div class="van-select-groupbox" v-else-if="items.type == 3 && items.isShow">
          <div class="van-select-label">
            {{items.title}}：
          </div>
          <el-select v-model="checkbox[items.name]" :placeholder="checkbox[items.name] == '' ? '请选择':items.options[checkbox[items.name]]">
            <el-option v-for="item in items.options" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="addPiaoBtnbox">
      <span class="addPiaoBtn" @click="addPiaoBtn"> 提交 </span>
    </div>



  </div>
</template>
<script>
    export default {
      name: "Orderdetails",
    data() {
      return {
        order_no: '',
        typelist: [
          {
            type: 2, //1 输入框 2 单选 3 下拉
            title: '发票类型',
            name: 'invoice_type',
            isShow: false,
            isRequired: true,
            reg: '',
            options: [{
                text: '增值税电子普通发票',
                value: 3,
                check: true
              },
              {
                text: '增值税专用发票',
                value: 2,
                check: true
              }
            ]
          },
          {
            type: 2, //1 输入框 2 单选 3 下拉
            title: '配送方式',
            name: 'get_type',
            isRequired: true,
            isShow: false,
            reg: '',
            options: [
              /*{
                              text: '现场领取',
                              value: 1,
                              check: true
                            },*/
              {
                text: '发票邮寄',
                value: 2,
                check: true
              }
            ]
          },
          {
            type: 2, //1 输入框 2 单选 3 下拉
            title: '抬头类型',
            name: 'type',
            isShow: false,
            isRequired: true,
            reg: '',
            options: [{
                text: '企业',
                value: 2,
                check: true
              },
              {
                text: '个人',
                value: 1,
                check: true
              }
            ]
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '发票抬头',
            name: 'title',
            disabled: false,
            isShow: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写发票抬头',
            options: []
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '税号',
            name: 'tax_no',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$',
            placeholder: '请填写纳税人识别号',
            options: []
          },
          {
            type: 3, //1 输入框 2 单选 3 下拉
            title: '发票项目',
            name: 'invoice_project',
            isShow: false,
            isRequired: true,
            reg: '',
            options: [{
              text: '会议费',
              value: 2,
              check: true
            }, ]
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '开户银行',
            name: 'bank_name',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写开户银行',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '银行账号',
            name: 'bank_no',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写账号',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '公司电话',
            name: 'tel',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写电话',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '公司地址',
            name: 'cmp_address',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写地址',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '可开票总金额',
            name: 'price',
            isShow: false,
            disabled: true,
            isRequired: true,
            reg: '',
            placeholder: '',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '电子邮箱',
            name: 'email',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$',
            placeholder: '请填写电子邮箱',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '收件人',
            name: 'name',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写收件人',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '联系电话',
            name: 'phone',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写联系电话',
          },
          {
            type: 1, //1 输入框 2 单选 3 下拉
            title: '详细地址',
            name: 'address',
            isShow: false,
            disabled: false,
            isRequired: true,
            reg: '',
            placeholder: '请填写地址',
          },
        ],
        checkbox: {
          price: '', //开票金额
          invoice_project: 2, //发票项目
          type: 2, //1:个人 2:企业
          invoice_type: 3, //1纸质普通发票 2纸质专用发票 3电子普通发票
          title: '', //	发票抬头
          tax_no: '', //税号type为1个人可以为空
          cmp_address: '', //公司地址(专票必须)
          tel: '', //	公司电话(专票必须)
          bank_name: '', //	开户银行(专票必须)
          bank_no: '', //	银行账号(专票必须)
          name: '', //	收件人姓名(纸质必须)
          address: '', //	收件地址(纸质必须)
          phone: '', //	收件人手机(纸质必须)
          email: '', //	邮件地址(电子必须)
          order_no: '', //	关联订单号(多个","隔开)
          get_type: 2, //	纸质发票领取方式，1：现场领取，2：发票邮寄
          dep_code: '', //	部门编码
          conference_code: '' //会议编码
        },
        box: [
          [0, 1, 2, 3, 4, 5, 10, 12, 13, 14], //纸质普票
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14], //纸质专票
          [0, 2, 3, 4, 5, 10, 11], //电子发票
        ],
        piao_data: [{
          num: '',
          btn: false
        }],
        wxbox: '',
      };
    },
    created: function() {
      var _this = this;
      var local = JSON.parse(localStorage.getItem('invoiceMenu'));
      _this.checkbox.price = local.allAmount;
      _this.checkbox.order_no = local.order_no;
      _this.checkbox.dep_code = local.dep_code;
      _this.checkbox.conference_code = local.code;
      _this.piao_data[0].num = local.allAmount;
      var piao_data = JSON.parse(localStorage.getItem('piao_data'));
      if (piao_data) {
        _this.piao_data = piao_data;
      }
      var piao_checkbox = JSON.parse(localStorage.getItem('piao_checkbox'));
      if (piao_checkbox) {
        _this.checkbox = piao_checkbox;
        localStorage.removeItem('piao_checkbox');
      }
      var wx_box = JSON.parse(localStorage.getItem('wx_box'));
      if (wx_box) {
        _this.wxbox = wx_box;
        localStorage.removeItem('wx_box');
      }
      _this.changeRadio('invoice_type');
    },
    methods: {
      addWxbox(boxs) {
        var _this = this;
        _this.checkbox.title = boxs.title;
        _this.checkbox.bank_name = boxs.bankName;
        _this.checkbox.bank_no = (boxs.bankAccount).replace(/\s*/g, "");;
        _this.checkbox.tax_no = (boxs.taxNumber).replace(/\s*/g, "");
        _this.checkbox.cmp_address = boxs.companyAddress;
        _this.checkbox.tel = boxs.telephone;
      },
      changeRadio(text) {
        var _this = this;
        if (text == 'invoice_type') {
          var radioN = _this.checkbox.invoice_type;
          for (var i = 0; i < _this.typelist.length; i++) {
            _this.typelist[i].isShow = false;
            _this.checkbox.cmp_address = '';
            _this.checkbox.tel = '';
            _this.checkbox.bank_name = '';
            _this.checkbox.bank_no = '';
            if (_this.wxbox != '') {
              _this.addWxbox(_this.wxbox);
            }
            _this.typelist[2].options = [{
                text: '企业',
                value: 2,
                check: true
              },
              {
                text: '个人',
                value: 1,
                check: true
              }
            ];
            _this.checkbox.type = 2;
            if (radioN == 3) {
              if (_this.box[2].indexOf(i) != -1) {
                _this.typelist[i].isShow = true;
              }
              _this.checkbox.get_type = 2;
            } else if (radioN == 1) {
              if (_this.box[0].indexOf(i) != -1) {
                _this.typelist[i].isShow = true;
              }
              _this.checkbox.get_type = 2;
            } else if (radioN == 2) {
              if (_this.box[1].indexOf(i) != -1) {
                _this.typelist[i].isShow = true;
                _this.checkbox.type = 2;
                _this.typelist[2].options = [{
                  text: '企业',
                  value: 2,
                  check: true
                }]
              }
              //   _this.checkbox.get_type = 1;
            }
          }
        }
        if (text == 'type') {
          if (_this.checkbox.type == 1) {
            _this.typelist[4].isRequired = false;
          } else {
            _this.typelist[4].isRequired = true;
          }
        }
      },
      // 校验函数返回 true 表示校验通过，false 表示不通过
      validator(i) {

        var _this = this;
        var car_filed = _this.typelist[i];
        var regular = new RegExp(car_filed.reg);
        if (car_filed.isRequired) {
          if (_this.checkbox[car_filed.name] != '') {
            if (car_filed.reg != '') {
              if (!(regular.test(_this.checkbox[car_filed.name]))) {
                _this.$message({
                  showClose: true,
                  message: car_filed.title + '错误！',
                  type: 'error'
                });
                return false;
              }
            }
          } else {
            _this.$message({
              showClose: true,
              message: car_filed.title + '不能为空！',
              type: 'error'
            });
            return false;
          }
        }
      },
      //提交开票信息
      addPiaoBtn() {
        var _this = this,
          status = true,
          each_amount = '';
        for (var i = 0; i < _this.typelist.length; i++) {
          var boxs = _this.box[_this.checkbox.invoice_type - 1];
          if (status) {
            if (boxs.indexOf(i) != -1) {
              var car_filed = _this.typelist[i];
              if (car_filed.type == 1) {
                var regular = new RegExp(car_filed.reg);
                if (car_filed.isRequired) {
                  if (_this.checkbox[car_filed.name] != '') {
                    if (car_filed.reg != '') {
                      if (!(regular.test(_this.checkbox[car_filed.name]))) {错误
                        _this.$message({
                          showClose: true,
                          message: car_filed.title + '错误！',
                          type: 'error'
                        });
                        status = false;
                      }
                    }
                  } else {
                    _this.$message({
                      showClose: true,
                      message: car_filed.title + '不能为空！',
                      type: 'error'
                    });
                    status = false;
                  }
                }
              } else if (car_filed.type == 2 || car_filed.type == 3) {
                if (_this.checkbox[car_filed.name] == '') {
                  _this.$message({
                    showClose: true,
                    message: '请选择' + car_filed.title + '！',
                    type: 'error'
                  });
                  status = false;
                }
              }
            }
          }
        };
        for (var s = 0; s < _this.piao_data.length; s++) {
          each_amount += ',' + _this.piao_data[s].num;
        }
        if (status) {
          let url = "/ac1/conference/invoice/add";
          let params = {
            invoice_project: _this.checkbox.invoice_project,
            type: _this.checkbox.type,
            invoice_type: _this.checkbox.invoice_type,
            title: _this.checkbox.title,
            tax_no: _this.checkbox.tax_no,
            cmp_address: _this.checkbox.cmp_address,
            tel: _this.checkbox.tel,
            bank_name: _this.checkbox.bank_name,
            bank_no: _this.checkbox.bank_no,
            name: _this.checkbox.name,
            address: _this.checkbox.address,
            phone: _this.checkbox.phone,
            email: _this.checkbox.email,
            order_no: _this.checkbox.order_no,
            get_type: _this.checkbox.get_type,
            dep_code: _this.checkbox.dep_code,
            conference_code: _this.checkbox.conference_code,
            is_each: _this.piao_data.length > 1 ? '1' : '0',
            need_num: _this.piao_data.length,
            each_amount: each_amount.substr(1)
          };
          _this.$post(url, params).then(res => {
            if (res.code == "1") {
              _this.$message({
                showClose: true,
                message:  '提交申请成功！',
                type: 'success'
              });
              setTimeout(function() {
                localStorage.removeItem('piao_data');
                localStorage.removeItem('piao_checkbox');
                _this.$emit('closeInvoiceTan');
              }, 1000)
            } else {
              _this.$message({
                showClose: true,
                message: res.msg,
                type: 'error'
              });
            }
          }, function(res) {
            console.log(res.msg);
          });
        }
      },
      goNumber() {
        var _this = this;
        localStorage.setItem('piao_checkbox', JSON.stringify(_this.checkbox));
        localStorage.setItem('wx_box', JSON.stringify(_this.wxbox));
        _this.$emit('openInvoiceNumDialog',1);
      },
    },
    mounted() {},
    beforeDestroy() {
      var _this = this;
      localStorage.removeItem('piao_data');
    }
  }
</script>
<style>
  .hy-piao {
    width: 100%;
    background: #F7F7F7;
    overflow: hidden;
  }
  .hy-piao .title {
    width: 100%;
    padding: 0 15px;
    overflow: hidden;
    line-height: 17.5px;
    margin-bottom: 10px;
    background: #FFF;
  }
  .hy-piao .title h5 {
    float: left;
    font-size: 15px;
    color: #333;
    font-weight: 600;
    border-left: 3px solid #0098f9;
    padding-left: 2.5px;
    line-height: 17.5px;
    overflow: hidden;
    width: 100%;
  }
  .hy-piao .title h5 > span {
    float: right;
    font-weight: 400;
    font-size: 13px;
  }
  .hy-piao .title h5 > span b {
    font-weight: 400;
    color: #ff0000;
  }
  .hy-piao .typelist {
    width: 100%;
    background: #FFF;
  }
  .hy-piao .typelist > div > div {
    height: 50px;
    line-height: 50px;
    padding: 5px 12.5px;
    font-size: 14px;
    border-bottom: 0.5px solid #ebebeb;
  }
  .hy-piao .typelist > div > div  h5{
    margin-bottom: 0px;
  }
  .hy-piao .typelist > div > div .van-field__label {
    width: auto;
    min-width: 90px;
    max-width: 110px;
    font-size: 13px;
    display: inline-block;
  }
  .hy-piao .typelist > div > div   .el-input{
    padding: 0 5px;
    font-size: 14px;
    width: 65%;
  }
  .hy-piao .typelist > div > div .van-checkbox__icon {
    height: auto;
  }
  .hy-piao .typelist > div > div .van-checkbox__icon .van-icon {
    width: 15px;
    height: 15px;
    font-size: 12px;
    margin-top: -3px;
  }
  .hy-piao .typelist > div > div .van-checkbox__label {
    font-size: 14px;
    line-height: 15px;
  }
  .hy-piao .typelist > div > div.van-checkbox {
    height: 45px;
    line-height: 35px;
  }
  .hy-piao .typelist > div > div.van-checkbox .van-checkbox__icon--checked .van-icon {
    background-color: #FFF;
    color: #f95d34;
    border-color: #f95d34;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox {
    height: auto;
    padding: 10px 12.5px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox h5 {
    font-size: 14px;
    line-height: 20px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-radio-group {
    line-height: 25px;
    min-height: 20px;
    padding: 7.5px 0px 0px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-radio-group .van-radio {
    margin: 0 10px 5px 0px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-radio-group .van-radio .van-radio__icon {
    height: 20px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-radio-group .van-radio .van-radio__icon .van-icon {
    width: 15px;
    height: 15px;
    font-size: 12px;
    margin: 2.5px 0px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-radio-group .van-radio .van-radio__icon--checked .van-icon {
    background-color: #FFF;
    color: #f95d34;
    border-color: #f95d34;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-radio-group .van-radio .van-radio__label {
    font-size: 14px;
    line-height: 15px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-checkbox-group {
    line-height: 25px;
    min-height: 20px;
    padding: 7.5px 0px 0px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-checkbox-group .van-checkbox {
    margin: 0 10px 5px 0px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-checkbox-group .van-checkbox .van-checkbox__icon {
    height: 20px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-checkbox-group .van-checkbox .van-checkbox__icon .van-icon {
    width: 15px;
    height: 15px;
    font-size: 12px;
    margin: 2.5px 0px;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-checkbox-group .van-checkbox .van-checkbox__icon--checked .van-icon {
    background-color: #FFF;
    color: #f95d34;
    border-color: #f95d34;
  }
  .hy-piao .typelist > div > div.van-radio-groupBox .van-checkbox-group .van-checkbox .van-checkbox__label {
    font-size: 14px;
    line-height: 15px;
  }
  .hy-piao .typelist > div > div.van-check-time {
    height: auto;
    padding: 8.5px 12.5px;
  }
  .hy-piao .typelist > div > div.van-check-time .van-cell {
    padding: 10px 0px;
  }
  .hy-piao .typelist > div > div.van-check-time .van-cell::after {
    border: none;
  }
  .hy-piao .typelist > div > div.van-check-time .van-cell__title {
    font-size: 14px;
  }
  .hy-piao .typelist > div > div.van-check-time .van-cell__value {
    font-size: 14px;
  }
  .hy-piao .typelist > div > div.van-select-groupbox {
    height: auto;
    padding: 5px 12.5px;
    display: flex;
  }
  .hy-piao .typelist > div > div.van-select-groupbox .van-select-label {
    -webkit-box-flex: 0;
    -webkit-flex: none;
    flex: none;
    box-sizing: border-box;
    width: auto;
    min-width: 90px;
    max-width: 100px;
    text-align: left;
    line-height: 39px;
    color: #646566;
    font-size: 13px;
  }

  .hy-piao .typelist > div > div.active {
    border-bottom: 0.5px solid #f95d34;
  }
  .hy-piao .typelist > div > div.active .van-field__label,
  .hy-piao .typelist > div > div.active h5,
  .hy-piao .typelist > div > div.active .van-cell__title,
  .hy-piao .typelist > div > div.active .van-select-label {
    color: #ee0a24;
  }
  .hy-piao .typelist > div > div .el-select{
    width: 65%;
  }
  .hy-piao .typelist > div > div .el-select .el-input{
    width: 100%;
  }
  .hy-piao .typelist > div:last-child > div {
    border-bottom: none;
  }
  .hy-piao .addPiaoBtnbox {
    width: 100%;
    margin: 15px auto;
    overflow: hidden;
    text-align: center;
    background-color: #FFF;
  }
  .hy-piao .addPiaoBtnbox a,
  .hy-piao .addPiaoBtnbox span {
    width: 100px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    text-align: center;
    font-size: 15px;
    vertical-align: middle;
    margin: 0 15px;
  }
  .hy-piao .addPiaoBtnbox .link {
    border: 1px solid #333333;
  }
  .hy-piao .addPiaoBtnbox .addPiaoBtn {
    background: #ed6b00;
    color: #FFF;
    border: 1px solid #ed6b00;
  }

</style>
